import "./footer.css";
import { Link } from "react-router-dom";
import { routes } from "../../../routes";
import DroppieLogo from "../../../assets/images/logo/droppie-web-logo.svg";
import Mascot from "../../../assets/images/Mascot.png";
import { icons } from "../../../utils/globalImages";
import { useSelector, useDispatch } from "react-redux";
import {
  setAccount,
  togglePayment,
  toggleSearchModal,
} from "../../../redux/slices/accountSlice";
import { toggleOnboard } from "../../../redux/slices/onBoardingSlice";

const marqueeItems = [
  "GUARANTEED WINS",
  "BIG PRIZES",
  "INSTANT REWARDS",
  "JACKPOT BOXES",
  "WIN EVERY TIME",
  "PRIZE INSIDE",
];

const Footer = () => {
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);
  const openWithdrawModal = () => {
    if (isLoggedIn) {
      dispatch(togglePayment({ payment: true }));
    } else {
      dispatch(toggleOnboard({ login: true }));
    }
  };

  return (
    <div className={`footer-wrapper ${isDarkMode ? "dark" : "light"}`}>
      {/* ── Scrolling Marquee Strip ── */}
      <div className="footer-marquee-strip">
        <div className="footer-marquee-track">
          {[...marqueeItems, ...marqueeItems, ...marqueeItems].map(
            (item, i) => (
              <span key={i} className="marquee-item">
                <span className="marquee-star">✦</span>
                {item}
              </span>
            ),
          )}
        </div>
      </div>
      <div className="container">
        {/* ── Main Footer Body ── */}
        <div className={`footer-body ${isDarkMode ? "dark" : "light"}`}>
          {/* Dot-grid overlay */}
          <div className="footer-dot-grid" />

          <div className="footer-inner">
            {/* LEFT ─ Logo + Contact */}
            <div className="footer-col-left">
              <div className="footer-logo-wrap">
                {/* Replace src with your logo */}
                <img
                  src={DroppieLogo}
                  alt="Droppie"
                  className="footer-logo-img"
                />
              </div>

              <div className="footer-contact-list">
                <div className="footer-contact-row d-start">
                  <span className="footer-contact-icon">
                    <i className="fas fa-map-marker-alt" />
                  </span>
                  <p className="mb-0">
                    742 Evergreen Terrace Springfield, IL 62704, United States
                  </p>
                </div>

                <div className="footer-contact-row d-start">
                  <span className="footer-contact-icon">
                    <i className="fa fa-envelope" />
                  </span>
                  <p className="mb-0">support@droppie.com</p>
                </div>
              </div>
            </div>

            {/* CENTER ─ Mascot */}
            <div className="footer-col-center">
              {/* Replace src with your mascot image */}
              <img
                src={Mascot}
                alt="Droppie Mascot"
                className="footer-mascot"
              />
            </div>

            {/* RIGHT ─ Deposit Methods */}
            <div className="footer-col-right">
              <h2 className="deposit-title">10+ DEPOSIT METHODS</h2>
              <p className="deposit-subtitle">
                Choose your preferred method and make a deposit with 5% Bonus!
              </p>

              <div className="payment-icons-row">
                {/* Replace each src with the corresponding payment icon */}
                <img
                  src={icons.masterCard}
                  alt="Mastercard"
                  className="payment-icon"
                />
                <img src={icons.visa} alt="Visa" className="payment-icon" />
                <img
                  src={icons.applePay}
                  alt="Apple Pay"
                  className="payment-icon"
                />
                <img
                  src={icons.bitCoin}
                  alt="Bitcoin"
                  className="payment-icon"
                />
                <img
                  src={icons.ethereum}
                  alt="Ethereum"
                  className="payment-icon"
                />
                <img src={icons.tether} alt="Tether" className="payment-icon" />
                <a onClick={openWithdrawModal} className="ft-deposit-btn">
                  Deposit Now{" "}
                  <span>
                    <svg
                      style={{ marginBottom: "3px" }}
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="black"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 4 14 12 6 20" />
                      <polyline points="12 4 20 12 12 20" />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ── Bottom Bar ── */}
        <div className={`footer-bottom-bar ${isDarkMode ? "dark" : "light"}`}>
          <div className="footer-bottom-inner">
            {/* Nav links */}
            <nav className="footer-nav">
              <Link to={routes.FAQ}>FAQs</Link>
              <Link to={routes.TERMS}>Terms of Use</Link>
              <Link to={routes.PRIVACYPAYMENTS}>Privacy Policy</Link>
              <Link to={routes.PROVABLYFAIR}>Provably Fair</Link>
              <Link to={routes.COOKIE}>Cookie Policy</Link>
              <Link to={routes.AMLPOLICY}>AML Policy</Link>
              <Link to={routes.CONTACTUS}>Contact Us</Link>
            </nav>

            {/* Social icons */}
            <div className="footer-socials">
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                className="social-btn"
              >
                <i className="fab fa-tiktok" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                className="social-btn"
              >
                <i className="fab fa-snapchat-ghost" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                className="social-btn"
              >
                <i className="fab fa-x-twitter" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                className="social-btn"
              >
                <i className="fab fa-instagram" />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                className="social-btn"
              >
                <i className="fab fa-facebook-f" />
              </a>
            </div>
          </div>

          {/* Copyright */}
          <p className="footer-copyright">
            © {new Date().getFullYear()}{" "}
            <span className="copyright-brand">Droppie</span> - All rights
            reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
